import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GetSimXInstitutionScenarioPackagesRequest } from '../models/requests/get-simx-institution-scenario-packages-request.model';
import { SetSimXInstitutionScenarioPackagesRequest } from '../models/requests/set-simx-institution-scenario-packages-request.model';
import { GetSimXInstitutionScenarioPackagesResponse } from '../models/responses/get-simx-institution-scenario-packages-response.model';
import { SetSimXInstitutionScenarioPackagesResponse } from '../models/responses/set-simx-institution-scenario-packages-response.model';
import { UpdateSimXInstitutionScenarioPackagesResponse } from '../models/responses/update-simx-institution-scenario-packages-response.model';
import { DataService } from './data.service';

@Injectable({ providedIn: 'root' })
export class InstitutionScenarioPackageDataService {
  private readonly _dataService = inject(DataService);
  private readonly _http = inject(HttpClient);

  getInstitutionScenarioPackagesForInstitution(
    institutionId: string,
    request: GetSimXInstitutionScenarioPackagesRequest,
  ): Observable<GetSimXInstitutionScenarioPackagesResponse> {
    const url =
      this._dataService.institutionScenarioPackagesForInstitutionUrl(
        institutionId,
      );
    return this._http.post<GetSimXInstitutionScenarioPackagesResponse>(
      url,
      request,
    );
  }

  getInstitutionScenarioPackagesForScenarioPackage(
    scenarioPackageId: string,
    request: GetSimXInstitutionScenarioPackagesRequest,
  ): Observable<GetSimXInstitutionScenarioPackagesResponse> {
    const url =
      this._dataService.institutionScenarioPackagesForScenarioPackageUrl(
        scenarioPackageId,
      );
    return this._http.post<GetSimXInstitutionScenarioPackagesResponse>(
      url,
      request,
    );
  }

  setInstitutionScenarioPackageItemsForInstitution(
    institutionId: string,
    request: SetSimXInstitutionScenarioPackagesRequest,
  ): Observable<SetSimXInstitutionScenarioPackagesResponse> {
    const url =
      this._dataService.institutionScenarioPackagesForInstitutionUrl(
        institutionId,
      );
    return this._http.patch<UpdateSimXInstitutionScenarioPackagesResponse>(
      url,
      request,
    );
  }

  setInstitutionScenarioPackageItemsForScenarioPackage(
    scenarioPackageId: string,
    request: SetSimXInstitutionScenarioPackagesRequest,
  ): Observable<SetSimXInstitutionScenarioPackagesResponse> {
    const url =
      this._dataService.institutionScenarioPackagesForScenarioPackageUrl(
        scenarioPackageId,
      );
    return this._http.patch<UpdateSimXInstitutionScenarioPackagesResponse>(
      url,
      request,
    );
  }
}
